module.exports = __webpack_public_path__ + "static/media/logo.dc930223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tengxian/logo.png
// module id = 944
// module chunks = 0